export async function collectAsyncIterableToSet(values) {
    const collected = new Set();
    for await (const value of values)
        collected.add(value);
    return collected;
}
//# sourceMappingURL=async-iterable.js.map